export default {
  /**
   * Accepts number only
   * Disregards other character
   */
  isNumber(event) {
    event = (event) ? event : window.event;
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
      event.preventDefault();
    } else {
      return true;
    }
  },
  
  /**
   * Accepts number only
   * Disregards other character except period (charCode = 46)
   */
   isCurrency(event) {
    event = (event) ? event : window.event;
    let charCode = (event.which) ? event.which : event.keyCode;
    // console.log('charCode', charCode)
    if ((charCode > 31 && (charCode < 46 || charCode > 57 ))) {
      event.preventDefault();
    } else {
      return true;
    }
  },

  /**
   * Adds thousands separator and peso symbol prefix
   * 
   * Note: Decimal format is not yet implemented
   * @param {Number} value value to be formatted
   * @param {String} symbol symbol to be used
   * @param {Boolean} decimal number of decimal places
   */
  formatToCurrency(value, symbol='') {
    if (!value) return;
    let formattedValue = parseFloat(value).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 6,
    });
    formattedValue = symbol ? symbol + formattedValue : formattedValue;
    return formattedValue;
  },

  /**
   * Formats number with thousands separator (NO DECIMALS)
   * @param {Number|String} value
   * @param {String} symbol optional (₱, $, etc.)
   */
  formatThousands(value, symbol = '') {
    if (value === null || value === undefined) return '';

    // Remove non-numeric characters
    const numericValue = Number(String(value).replace(/[^\d]/g, ''));

    if (isNaN(numericValue)) return '';

    const formatted = numericValue.toLocaleString('en-US', {
      maximumFractionDigits: 0,
    });

    return symbol ? `${symbol}${formatted}` : formatted;
  }
}